import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateUserRegionalActions } from 'store/ducks/settings/users';

export function* createUserRegionalRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/user-regionals`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateUserRegionalActions.success(data));
    notify('success', 'Regional adicionado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateUserRegionalActions.failure(errorMessage));
  }
}
